<template>
  <div class="content">
    <div class="container">
      <button
        class="float-right btn btn-light"
        @click="$router.go(-1)"
      >
        Back Orders
      </button>
      <h1 class="mb-5">
        Order #{{ id_order }}
      </h1>
      <div class="row">
        <div class="col-8">
          <card-box>
            <card-title> Order Details</card-title>
            <table class="mt-3 table table-sm table-hover w-100 d-block d-md-table table-responsive">
              <tr
                v-for="item in items"
                :key="item.id"
              >
                <td width="100">
                  <img
                    :src="item.thumbnail"
                    class="thumb-lg mt-1 img-thumbnail"
                    alt=""
                  >
                  <button
                    v-if="order.status_fulfillment == 0"
                    class="mt-1 btn btn-block btn-light btn-sm"
                    @click="showModal(item)"
                  >
                    <i
                      class="fi-cog"
                    /> Edit
                  </button>
                </td>
                <td class="product">
                  <strong>{{ item.name }}</strong>
                  <p>
                    <strong>Sku</strong>: {{ item.id_product }}
                  </p>
                  <div v-html="item.select_option.replace('<p>','').replace('</p>','')" />
                </td>
                <td class="align-middle">
                  ${{ item.price }} <br>
                  <span class="text-primary">${{ item.base_cost_item }}</span> <br>
                  <span class="text-danger">${{ item.artist_cost_item }}</span>
                </td>
                <td
                  width="80"
                  class="align-middle"
                >
                  {{ item.qty }} item(s)
                </td>
                <td class="align-middle">
                  <div class="text-right">
                    ${{ item.subtotal }}
                  </div>
                  <div class="text-right">
                    <span class="text-primary">${{ item.base_cost }}</span>
                  </div>
                  <div class="text-right">
                    <span class="text-danger">${{ item.artist_cost }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <div class="text-right">
                    Subtotal:
                  </div>
                  <div class="text-right">
                    Shipping:
                  </div>
                  <div class="text-right">
                    <strong>Grand Total:</strong>
                  </div>
                  <div class="text-right text-danger">
                    Artist {{ order.artist_rate }}%:
                  </div>
                  <div class="text-right text-primary">
                    Base Cost:
                  </div>
                  <div class="text-right text-success">
                    <strong>Profit:</strong>
                  </div>
                </td>
                <td colspan="2">
                  <div class="text-right">
                    ${{ order.payment_subtotal }}
                  </div>
                  <div class="text-right">
                    ${{ order.shipping_price }}
                  </div>
                  <div class="text-right">
                    <strong>${{ order.payment_total_shop }}</strong>
                  </div>
                  <div class="text-right text-danger">
                    ${{ order.artist_cost }}
                  </div>
                  <div class="text-right text-primary">
                    ${{ order.base_cost }}
                  </div>
                  <div class="text-right text-success">
                    <strong> ${{ order.profit }}</strong>
                  </div>
                </td>
              </tr>
            </table>
          </card-box>


          <div class="row">
            <div class="col" />
            <div class="col text-right">
              <!--<button @click="updateStatus(3)" class="btn btn-warning btn-sm mr-3">Refund Order</button>-->
              <button
                v-if="order.status_fulfillment == 0 && order.status_order == 1"
                class="btn btn-danger btn-sm"
                @click="cancelOrder"
              >
                Cancel Order
              </button>
            </div>
          </div>
        </div>
        <div class="col-4">
          <card-box>
            <button
              v-if="order.status_fulfillment == 0"
              class="float-right btn btn-sm btn-light"
              @click="showModalCustomer"
            >
              <i
                class="dripicons-document-edit"
              />
            </button>
            <card-title>Customer</card-title>
            <h6 class="mt-3">
              Billing Address
            </h6>
            <div v-if="order.billing_full_name !=null">
              {{ order.billing_full_name }} <br>
              {{ order.billing_email }} <br>
              {{ order.billing_address }} {{ order.billing_address_2 }} {{ order.billing_city }}
              {{ order.billing_zip }} <br>
              {{ order.billing_country }} <br>
            </div>
            <div v-if="order.billing_full_name ==null">
              Same Shipping Address
            </div>

            <hr>
            <h6 class="mt-3">
              Shipping Address
            </h6>
            {{ order.full_name }} <br>
            {{ order.email }} <br>
            {{ order.address }} {{ order.address_2 }} {{ order.city }} {{ order.zip }} <br>
            {{ order.country }} <br>
          </card-box>
          <card-box>
            <card-title>Status</card-title>
            <h6 class="mt-3">
              Order status
            </h6>
            <div :class="this.$config.order_class[order.status_order]">
              {{ statusOrder() }}
            </div>
            <hr>
            <h6>Fulfillment Status</h6>
            <div class="text-success">
              {{ statusFulfillment() }}
            </div>
          </card-box>
        </div>
      </div>
    </div>

    <b-modal
      id="refEditItem"
      ref="refEditItem"
      hide-footer
      title="Edit Item"
    >
      <order-edit-item
        :item="item"
        @update="getOrder"
      />
    </b-modal>

    <b-modal
      id="refEditCustomer"
      ref="refEditCustomer"
      size="lg"
      hide-footer
      title="Edit Customer"
    >
      <order-edit-customer :customer="customer" />
    </b-modal>
  </div>
</template>

<script>
    import CardTitle from "@/components/CardTitle";
    import CardBox from "@/components/CardBox";
    import OrderEditItem from "@/components/OrderEditItem";
    import OrderEditCustomer from "@/components/OrderEditCustomer";

    export default {
        name: "OrderDetail",
        components: {OrderEditCustomer, OrderEditItem, CardBox, CardTitle},

        data: function () {
            return {
                item: {},
                id_order: 0,
                order: {},
                items: [],
                customer: {}
            }
        },
        mounted: function () {
            this.id_order = this.$route.params.id
            this.getOrder()
        },
        methods: {
            cancelOrder: function () {
                let vm = this
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Cancel it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then(async (result) => {
                    if (result.value) {
                        await this.$http.post(this.$config.api + 'order/cancel', {id: vm.order.id})
                        this.$swal('Cancelled', 'You successfully canceled order', 'success')
                    } else {
                        this.$swal('Cancelled', 'Your Order is still intact', 'info')
                    }
                })
            },
            statusFulfillment: function () {
                return this.$config.fulfillment[this.order.status_fulfillment]

            },
            statusOrder: function () {
                return this.$config.order[this.order.status_order]
            },
            showModalCustomer: function () {
                this.customer = this.order
                this.$refs.refEditCustomer.show()
            },
            showModal(item) {
                this.item = {id: 0}
                this.$refs.refEditItem.show()
                this.item = item
            },
            hideModal() {
                this.item = null
                this.$refs.refEditItem.hide()
            },
            baseCostIncShipping: function () {
                return (parseFloat(this.order.base_cost) + parseFloat(this.order.shipping_price) + parseFloat(this.order.artist_cost)).toFixed(2)
            },
            getOrder: function () {
                let vm = this
                this.$http.get(this.$config.api + 'order/' + this.id_order).then(function (res) {
                    vm.order = res.data.order
                    vm.items = res.data.items
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    td.product {
        p {
            font-weight: normal;
            margin-bottom: 0;
            padding: 0;
            line-height: 1.2em;
        }
        div p {
            font-weight: normal;
            margin-bottom: 0;
            padding: 0;
            line-height: 1.2em;
        }

    }
</style>